import { FC, useContext, useEffect, useRef, useState } from "react";
import Header from "../SubComponents/Header";
import { Formik, Form } from "formik";
import {
  Typography,
  Grid,
  Container,
  Box,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import Textfield from "../FormsUI/Textfield";
import ButtonSubmit from "../FormsUI/Button";
import { useTheme } from "@material-ui/core";
import AuthImage from "../SubComponents/AuthImage";
import useStyles from "../Styles/AuthStyles";
import newimageauth from "../../assets/images/authbanner.png";
import { RecoverPasswordValidation } from "../../helpers/Validations";
import { useHistory } from "react-router-dom";
import AuthContext from "../../store/Auth/AuthContext";
import Recaptcha from "./Recaptcha";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const INITIAL_FORM_STATE = {
  email: "",
  captcha: null,
};

const RecoverPassword: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActive1 = useMediaQuery(theme.breakpoints.down("xs"));
  const { isAuth, forgotPassword, showresetlink, setShowResetLink } =
    useContext<any>(AuthContext);
  const history = useHistory();
  const [captcha, setCaptcha] = useState<any>(null);
  const captchaRef = useRef<any>(null);
  const [disableToResend, setDisableToResend] = useState(true);

  if (isAuth) {
    history.push("/deals");
  }

  useEffect(() => {
    setShowResetLink(false);
  }, []);

  useEffect(() => {
    if (showresetlink) {
      captchaRef.current?.reset();
      setCaptcha(null);
    }
  }, [showresetlink]);

  const [, setmyEmail] = useState("");

  return (
    <Box className={classes.authpages} component="section">
      <Header authPage loginPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            {!isActive && (
              <Grid className="borderleft" item md={5} sm={12}>
                <AuthImage image={newimageauth} />
              </Grid>
            )}
            <Grid className="borderleft  borderRight" item md={7} sm={12}>
              <Box
                className="validateEmailTextBox"
                pl={isActive ? 0 : 7}
                pr={isActive ? 0 : 7}
              >
                <Typography
                  variant={isActive ? "h1" : "h2"}
                  color="primary"
                  className="mb-16"
                >
                  Recover
                  <Typography
                    component="span"
                    variant={isActive ? "h1" : "h2"}
                    color="secondary"
                  >
                    {" "}
                    Password
                  </Typography>
                </Typography>
                <Box>
                  <Typography variant="body1">
                    Enter your email address to reset your password. You will
                    receive an <br />
                    email within a few minutes telling you how to reset your
                    password.
                  </Typography>
                  {!showresetlink && (
                    <Box mt={isActive ? 2 : 3}>
                      <Recaptcha setCaptcha={setCaptcha} ref={captchaRef} />
                    </Box>
                  )}
                </Box>
                {/* this code will be conditional based on send email */}
                {/* TODO: we do not need to check for isActive, same button can be reused */}
                {showresetlink && (
                  <Box mt={isActive ? 2 : 3}>
                    {isActive ? (
                      <>
                        <Box mt={4}>
                          <Button
                            onClick={() => {
                              setShowResetLink(false);
                              setDisableToResend(true);
                            }}
                            color="secondary"
                            size="large"
                            variant="contained"
                            disabled={disableToResend}
                          >
                            Resend Email{" "}
                            {disableToResend && (
                              <Box marginLeft={isActive ? "1.5rem" : ".75rem"}>
                                <CountdownCircleTimer
                                  isPlaying
                                  duration={60}
                                  colors="#3eb8aa"
                                  size={40}
                                  isGrowing
                                  strokeWidth={5}
                                  rotation="counterclockwise"
                                  onComplete={() => setDisableToResend(false)}
                                >
                                  {({ remainingTime }) => {
                                    return (
                                      <Typography variant="h4" color="primary">
                                        {remainingTime}
                                      </Typography>
                                    );
                                  }}
                                </CountdownCircleTimer>
                              </Box>
                            )}
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <Grid
                        className="pt-0 align-self-center"
                        item
                        md={6}
                        xs={6}
                      >
                        <Button
                          onClick={() => {
                            setShowResetLink(false);
                            setDisableToResend(true);
                          }}
                          variant="contained"
                          color="secondary"
                          size="large"
                          disabled={disableToResend}
                        >
                          Resend Email
                          {disableToResend && (
                            <Box marginLeft={isActive ? "1.5rem" : ".75rem"}>
                              <CountdownCircleTimer
                                isPlaying
                                duration={60}
                                colors="#3eb8aa"
                                size={40}
                                isGrowing
                                strokeWidth={5}
                                rotation="counterclockwise"
                                onComplete={() => setDisableToResend(false)}
                              >
                                {({ remainingTime }) => {
                                  return (
                                    <Typography variant="h4" color="primary">
                                      {remainingTime}
                                    </Typography>
                                  );
                                }}
                              </CountdownCircleTimer>
                            </Box>
                          )}
                        </Button>
                      </Grid>
                      // resend email
                    )}
                  </Box>
                )}

                <Box mt={isActive ? 3 : 3}>
                  <Formik
                    initialValues={{
                      ...INITIAL_FORM_STATE,
                    }}
                    validationSchema={RecoverPasswordValidation}
                    onSubmit={(values) => {
                      if (values.email !== null && captcha !== null) {
                      }
                      setmyEmail(values.email.toLowerCase());
                      forgotPassword(values.email.toLowerCase(), captcha);
                    }}
                  >
                    {!showresetlink && (
                      <Form>
                        <Grid
                          container
                          alignItems="center"
                          spacing={isActive ? 4 : 3}
                        >
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            className="error-absolute"
                          >
                            {isActive1 && (
                              <Typography
                                variant="subtitle1"
                                color="secondary"
                                className="fw-normal"
                              >
                                Email*
                              </Typography>
                            )}
                            <Textfield
                              name="email"
                              placeholder="Email"
                              margin="dense"
                            />
                          </Grid>

                          <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="btn-semi">
                              <ButtonSubmit disabled={!captcha}>
                                Send Email
                              </ButtonSubmit>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default RecoverPassword;
